import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService,
  IncomeTaxEntity,
  Lening,
  LeningGeldVerstrekker,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../../gedeelde-componenten/gedeelde-componenten.component";
import { Event, NavigationEnd, Router } from "@angular/router";
import { filter, Subscription } from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-eigenwoning-restschulden',
  templateUrl: './eigenwoning-restschulden.component.html',
  styleUrls: ['./eigenwoning-restschulden.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class EigenwoningRestschuldenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    private currentAangifte = {} as Aangifte;
    private focusedElementId: string | null = null;

    public dialogVisible = false;

    public restSchuldenFG = {} as FormGroup;

    showDialog(index: number) {
        this.index = index;
        this.dialogVisible = true;
    }

    public index = 0;

    constructor(private fb: FormBuilder,private router: Router, public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
        this.restSchuldenFG = this.fb.group({
            restschulden: this.fb.array<Lening>([]),
        });
    }

    //lening
    get restschulden(): FormArray {
        return this.restSchuldenFG.get('restschulden') as FormArray;
    }

    addRestschuld(): void {
        const restschuld = this.createRestschuldenFormGroup();
        this.restschulden.push(restschuld);
    }

    deleteRestschuld(index: number): void {
        this.restschulden.removeAt(index);
        this.restSchuldenFG.updateValueAndValidity()
        this.restSchuldenFG.markAsDirty()
        this.saveForm()
    }

    //kosten
    //aankoopkosten
    getKosten(index: number): FormArray {
        const outerGroup = this.restschulden.at(index) as FormGroup;
        return outerGroup.get('kosten') as FormArray;
    }

    addKosten(index: number): void {
        const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: '',
            bedrag: undefined,
        });
        const outerGroup = this.restschulden.at(index) as FormGroup;
        const innerArray = outerGroup.get('kosten') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteKosten(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getKosten(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm()
    }

    createRestschuldenFormGroup(restschuld?: Lening) {
        return this.fb.group({
                omschrijving: restschuld?.omschrijving || undefined,
                bedrag: restschuld?.bedrag || undefined,
                rekeningNummer: restschuld?.rekeningNummer || undefined,
                wozNummerWaarLeningBijHoort: restschuld?.wozNummerWaarLeningBijHoort || undefined,
                percentageBox1: 100,
                hoofdsom0101: restschuld?.hoofdsom0101 || undefined,
                hoofdsom3112: restschuld?.hoofdsom3112 || undefined,
                rente: restschuld?.rente || undefined,
                kosten: this.fb.array<OmschrijvingEnBedrag>([]),
                aanvangsDatum: restschuld?.aanvangsDatum || undefined,
                geldVerstrekker: restschuld?.geldVerstrekker || LeningGeldVerstrekker.BANK,

            }
        )
    }

    public createOmschrijvingEnBedragFormGroup(omschrijving?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: omschrijving ? omschrijving.omschrijving : undefined,
            bedrag: omschrijving ? omschrijving.bedrag : undefined,

        } as OmschrijvingEnBedrag))
    }



    formStructure: any;
    leningLength: any

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.updateForm()
                this.restSchuldenFG.valueChanges.subscribe(value => {
                    this.formStructure = value;
                });
                this.restschulden.valueChanges.subscribe(value => {
                    this.leningLength = value
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.restSchuldenFG.dirty;
  }

    private updateForm(): void {
        const restschuldenLijst = this.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.restschuldEigenWoningen || [];
        const formArray = this.restSchuldenFG.get('restschulden') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > restschuldenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Update leningen
        for (let i = 0; i < restschuldenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(restschuldenLijst[i]);
            } else {
                const formGroup = this.createRestschuldenFormGroup(restschuldenLijst[i])
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }

        // Update kosten lening (k)
        for (let i = 0; i < restschuldenLijst.length; i++) {
            const lening = restschuldenLijst[i];
            const kosten = lening.kosten || [];
            const kostenFormArray = this.getKosten(i);

            while (kostenFormArray.length > kosten.length) {
                kostenFormArray.removeAt(kostenFormArray.length - 1);
            }
            for (let k = 0; k < kosten.length; k++) {
                if (k < kostenFormArray.length) {
                    const control = kostenFormArray.at(k) as FormGroup;
                    control.patchValue(kosten[k]);
                } else {
                    const kost = this.createOmschrijvingEnBedragFormGroup(kosten[k]);
                    kostenFormArray.push(kost);
                }
            }
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    belastbareInkomstenUitEigenWoning: {
                        ...this.aangifte.box1?.belastbareInkomstenUitEigenWoning,
                        restschuldEigenWoningen: this.restSchuldenFG.value.restschulden
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            this.restSchuldenFG.markAsDirty()
        }, 0)
    }

}
